import React from 'react';

interface GCheckboxProps {
    label?: string;
    labelPosition?: 'left' | 'right';
    id?: string;
    className?: string;
    disabled?: boolean;
    isChecked: boolean;
    setIsChecked: (checked: boolean) => void;
    type?: 'radio' | 'checkbox';
}

const svg = (size: number = 13) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 13 13" fill="none">
            <path d="M4.26523 8.49627C4.62257 7.87995 4.94799 7.30549 5.3069 6.75143C7.11557 3.96073 9.44481 1.73508 12.4076 0.195859C12.4929 0.151911 12.5777 0.107439 12.664 0.0655843C12.7713 0.0137885 12.89 -0.0238812 12.9685 0.0948829C13.0574 0.229866 12.9392 0.297357 12.8471 0.363803C12.4165 0.675624 11.9943 0.998432 11.5915 1.34583C9.59915 3.06399 8.12219 5.16826 6.96332 7.51162C6.51913 8.40994 6.12831 9.3318 5.77777 10.2704C5.7333 10.3902 5.67209 10.4797 5.56326 10.5514C4.83603 11.0316 4.1135 11.5182 3.38836 12.0011C3.12206 12.1785 3.12101 12.1764 3.03155 11.8813C2.67892 10.7156 2.21014 9.60386 1.48447 8.61555C1.10516 8.09864 0.663589 7.64399 0.114239 7.30392C0.0263435 7.24951 -0.0599828 7.2066 0.0561654 7.09307C0.457452 6.70016 0.881759 6.3402 1.42902 6.16598C1.94279 6.00222 2.41104 6.10843 2.83326 6.43071C3.35959 6.83252 3.69129 7.38501 3.99422 7.95738C4.0795 8.118 4.15798 8.28228 4.26523 8.49627Z" fill="white" />
        </svg>
    )
}

const GCheckbox: React.FC<GCheckboxProps> = ({
    label,
    labelPosition = 'right',
    disabled = false,
    isChecked = false,
    setIsChecked = () => { },
    type = 'checkbox'
}) => {


    return (
        <div className="flex flex-col">
            <button
                onClick={() => setIsChecked(!isChecked)}
                className={`flex items-center ${labelPosition === 'left' ? 'flex-row-reverse' : 'flex-row'} gap-3`}>
                <div className={`flex items-center justify-center transition-all duration-300 ${type === 'radio' ? 'w-[20px] h-[20px] min-w-[20px] rounded-full' : 'w-[22px] h-[22px] min-w-[22px] rounded-[6px]'} ${isChecked ? 'bg-gradient-to-r from-[#4DBDFF] to-[#0086D3] shadow-[0_0_12px_rgba(0,134,211,0.4)]' : 'bg-white/[0.08] border border-white/20'}`}>
                    {isChecked && svg(type === 'radio' ? 10 : 13)}
                </div>
                <span className="text-white/60 text-[13px] font-medium text-left leading-tight">{label}</span>
            </button>
        </div>
    );
};

export default GCheckbox;